import BackendResponse from '@core/shared/backend-response';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';

import { Faq, GetFaqQueryParams, IGetAllFaqsUseCase } from '../../interfaces/faqs';

export default class GetAllFaqsUseCase extends HttpGetRequest<Faq[]> implements IGetAllFaqsUseCase {
  public async execute(query: GetFaqQueryParams): Promise<BackendResponse<Faq[]>> {
    const url = this.buildURL(`/faqs`, this.ensureQuery(query)).get();
    return (await this.dispatch(url)).data;
  }

  private ensureQuery(query: GetFaqQueryParams): Required<GetFaqQueryParams> {
    return { language: query?.language ?? 'en' };
  }
}
